"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 4px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DefaultHeading = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "ReviewSection__DefaultHeading",
  componentId: "tnhkeo-0"
})(_templateObject());

var ReviewSection = function ReviewSection(_ref) {
  var HeadingComponent = _ref.HeadingComponent,
      title = _ref.title,
      children = _ref.children;
  return _react.default.createElement(_UISection.default, null, title && _react.default.createElement(HeadingComponent, null, title), children);
};

ReviewSection.propTypes = {
  HeadingComponent: _propTypes.default.elementType,
  title: _propTypes.default.node,
  children: _propTypes.default.node
};
ReviewSection.defaultProps = {
  HeadingComponent: DefaultHeading
};
var _default = ReviewSection;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/ReviewSection.js
// module id = 853
// module chunks = 209 210 211 212